import * as apiConstants from '../constants/apiConstants';
import { GetAdminToken } from './token';

const axios = require('axios').default;
const _ = require("lodash");

export async function GetAllSchools() {
    try {
        let tempArr = [];

        const res = await axios({
            method: 'get',
            url: `${apiConstants.UTEST_AVENUE_API}/schools`
        });

        console.log(res)

        await res.data.data.map((school) => {
            tempArr.push({
                label: school.name,
                value: school.name
            })
        });

        console.log(tempArr);

        return {
            success: true,
            res: tempArr
        }
    } catch (err) {
        console.log(err);
        return {
            success: false,
            res: err
        }
    }
}

export async function AddNewSchool(school) {
    try {
        const res = await axios({
            method: 'post',
            url: `${apiConstants.UTEST_AVENUE_API}/schools/add`,
            data: {
                schoolName: school
            }
        });

        return {
            success: true,
            res: res.data
        }
    } catch (err) {
        console.log(err);
        return {
            success: false,
            res: err
        }
    }
}